module.exports = __webpack_public_path__ + "static/media/fontello2.eab211d6.ttf";